import DesignTemplatesPanel from './DesignTemplatesPanel.vue';
import { t } from './i18n';

type DesignerFacade = {
  designer?: {
    registerLeftPanel?: (panel: {
      id: string;
      label: string;
      description?: string;
      icon?: string;
      priority?: number;
      group?: string;
      render: (ctx: { config: Record<string, unknown>; activeView: string }) => { component: unknown; props?: Record<string, unknown> };
    }) => void;
  };
};

let registered = false;

function register(): void {
  const Veyop = (window as unknown as { Veyop?: DesignerFacade }).Veyop;
  if (registered || !Veyop?.designer?.registerLeftPanel) return;
  registered = true;

  Veyop.designer.registerLeftPanel({
    id: 'design-templates',
    group: 'templates',
    label: t('Templates'),
    description: t('Start from a ready-made design'),
    icon: 'M4 4h16v5H4V4zm0 7h7v9H4v-9zm9 0h7v9h-7v-9z',
    priority: 58,
    render: () => ({ component: DesignTemplatesPanel }),
  });
}

function boot(): void {
  register();
  const start = Date.now();
  const tick = () => {
    register();
    if (registered || Date.now() - start > 5000) return;
    setTimeout(tick, 50);
  };
  tick();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
